import { render, staticRenderFns } from "./CardStatistics.vue?vue&type=template&id=5fc52706&scoped=true"
import script from "./CardStatistics.vue?vue&type=script&lang=js"
export * from "./CardStatistics.vue?vue&type=script&lang=js"
import style0 from "./CardStatistics.vue?vue&type=style&index=0&id=5fc52706&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc52706",
  null
  
)

export default component.exports